// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as PLPMedia$Showside from "./PLPMedia.bs.js";
import * as Breadcrumbs$Showside from "./Breadcrumbs.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as SectionContent$Showside from "./SectionContent.bs.js";
import * as CollapsibleText$Showside from "./CollapsibleText.bs.js";
import * as StylableElement$Showside from "./StylableElement.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ListPageLayoutController$Showside from "../hook/ListPageLayoutController.bs.js";
import * as ScrollRestorationBreaker$Showside from "../utils/ScrollRestorationBreaker.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_CategoryDecoders.bs.js";
function ListPageHeading$Render(Props) {
  var titleDescriptionEnabled = Props.titleDescriptionEnabled;
  var category = Props.category;
  var position = Props.position;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var topLevelCategories = match$1.config.categories;
  var renderHeading = function (param) {
    return React.createElement(DataAttribute$Showside.make, {
      dataTestId: "clp-sectionheader-title",
      children: React.createElement("div", {
        "aria-level": 1,
        className: CSS$Showside.prefix(Cn.make(["font-heading", "font-semibold", "text-primary", "relative", isMobile ? "text-8xl" : "text-10xl", position ? "text-center" : "text-left"])),
        role: "heading"
      }, React.createElement(StylableElement$Showside.make, {
        className: "list-page__heading",
        children: category.title
      }))
    });
  };
  var renderDescription = function (param) {
    var description = category.description;
    if (description !== undefined && category.showDescription) {
      return React.createElement(CollapsibleText$Showside.make, {
        maxLines: isMobile ? 4 : 3,
        className: CSS$Showside.prefix(Cn.make([isMobile ? "text-xl" : "text-2xl leading-normal", "max-w-2xl", "text-secondary", position ? "text-center" : "text-left"])),
        readMoreAriaLabel: "Expand the collection description to read more",
        readLessAriaLabel: "Collapse the collection description to read less",
        buttonDataTestId: "plp-description-expand-button",
        contentDataTestId: "plp-description",
        children: React.createElement(StylableElement$Showside.make, {
          className: "list-page__subheading",
          children: description
        })
      });
    } else {
      return null;
    }
  };
  var renderBreadcrumbs = function (param) {
    var match = category.categoryType;
    var needBreadcrumbs;
    if (typeof match === "number") {
      needBreadcrumbs = false;
    } else {
      switch (match.TAG | 0) {
        case /* CustomComponentSection */5:
        case /* EmbedCodeSection */6:
          needBreadcrumbs = false;
          break;
        default:
          needBreadcrumbs = true;
      }
    }
    return React.createElement(ConditionalRender$Showside.When.make, {
      condition: needBreadcrumbs,
      children: React.createElement(Breadcrumbs$Showside.make, {
        categories: topLevelCategories,
        className: CSS$Showside.prefix(Cn.make([titleDescriptionEnabled ? "mt-6 mb-2" : "", isMobile ? "px-4" : "px-8"])),
        keepLast: !titleDescriptionEnabled,
        keepSingle: titleDescriptionEnabled
      })
    });
  };
  var renderTitleDescription = function (param) {
    if (titleDescriptionEnabled) {
      return React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make([isMobile ? "px-4" : "px-8", "space-y-2"]))
      }, renderHeading(undefined), renderDescription(undefined));
    } else {
      return null;
    }
  };
  var renderRelatedMedia = function (param) {
    return React.createElement(PLPMedia$Showside.Slider.make, {
      className: CSS$Showside.prefix("mt-4"),
      category: category,
      scrollableContainerRef: scrollableContainerRef,
      key: category.id
    });
  };
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["flex flex-col", titleDescriptionEnabled ? "py-4" : "py-2", "hide-on-empty", position ? "items-center" : "items-start"]))
  }, renderBreadcrumbs(undefined), renderTitleDescription(undefined), React.createElement(ScrollRestorationBreaker$Showside.make, {
    id: "top_of_related_media",
    adjustTo: /* AdjustToPrimaryNavbar */0
  }), renderRelatedMedia(undefined), React.createElement(ScrollRestorationBreaker$Showside.make, {
    id: "top_of_plp",
    adjustTo: /* AdjustToPrimaryNavbar */0
  }));
}
ListPageHeading$Render.displayName = "ListPageHeading.Render";
var Render = {
  make: ListPageHeading$Render
};
function ListPageHeading(Props) {
  var category = Props.category;
  var listPageContentType = Props.listPageContentType;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var onLinkClick = Props.onLinkClick;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var settings = match$1.config.settings;
  var match$2 = EntrypointContext$Showside.use(undefined);
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var ref = React.useRef(null);
  ListPageLayoutController$Showside.useTitleHeightSetter(ref);
  var parentCategory = Belt_Option.getWithDefault(Belt_Option.orElse(category, settings.indexNode), LegacyShowside_CategoryDecoders$ApiTypes.empty);
  var content;
  var exit = 0;
  if (typeof listPageContentType === "number") {
    content = null;
  } else {
    switch (listPageContentType.TAG | 0) {
      case /* CLPWithHeader */5:
        if (isMobile || !settings.smartbarEnabled) {
          content = null;
        } else {
          var category$1 = listPageContentType._0;
          var tmp = {
            index: 0,
            preferredContentType: /* Category */1,
            applyVisibleInHeader: true,
            category: category$1,
            parentCategory: parentCategory,
            layout: {
              TAG: /* SliderLayout */0,
              _0: listPageContentType._1
            },
            scrollableContainerRef: scrollableContainerRef,
            forcedSize: /* Xxxs */0,
            enableSmartCard: true,
            shouldCenterSlides: !isMobile,
            layoutControllerHook: ListPageLayoutController$Showside.useSubMenuSliderHeightSetter,
            onTitleClick: match$2.onSmartCardClick,
            key: category$1.id
          };
          if (onLinkClick !== undefined) {
            tmp.onLinkClick = Caml_option.valFromOption(onLinkClick);
          }
          content = React.createElement(SectionContent$Showside.make, tmp);
        }
        break;
      case /* IndexWithFilters */2:
      case /* CLPWithFilters */6:
      case /* PLPGrid */7:
      case /* PLPSlider */8:
      case /* StoreCategoryProducts */10:
        exit = 1;
        break;
      default:
        content = null;
    }
  }
  if (exit === 1) {
    content = React.createElement(ListPageHeading$Render, {
      titleDescriptionEnabled: settings.plpTitleDescriptionEnabled,
      category: parentCategory,
      appliedSort: match$3.productSort,
      appliedFilters: match$3.productFilters,
      position: settings.plpTitleDescriptionPosition,
      scrollableContainerRef: scrollableContainerRef
    });
  }
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref),
    className: CSS$Showside.prefix("smartnav-title relative z-20 bg-main")
  }, content);
}
ListPageHeading.displayName = "ListPageHeading";
var make = ListPageHeading;
export { Render, make };
/* react Not a pure module */